<template>
	<div class="student_page">
		<div class="page_header">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>岗位列表</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="search_bar">
				<el-input placeholder="请输入学生姓名或证件号进行搜索" v-model="keyword" @keyup.enter.native="searchData" clearable class="input-with-select">
					<el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
				</el-input>
			</div>
			<el-upload
				class="uploader-item"
				:action="fileUpload"
				:show-file-list="false"
				:headers="Token"
				name="file"
				:on-success="handleStudentUpload"
				accept=".xls,.xlsx">
				<el-button>批量导入修改状态</el-button>
			</el-upload>
			<el-button @click="exportData">导出表格</el-button>
		</div>
		<el-table :data="dataList" style="width: 100%">
			<el-table-column
				prop="username"
				label="姓名">
			</el-table-column>
			<el-table-column
				prop="p_company_name"
				label="单位名称">
			</el-table-column>
			<el-table-column
				prop="company_name"
				label="所属子公司">
			</el-table-column>
			<el-table-column
				prop="position_name"
				label="实习岗位名称">
			</el-table-column>
			<el-table-column
				prop="idcard"
				label="证件号">
			</el-table-column>
			<el-table-column
				prop="mobile"
				label="手机号码">
			</el-table-column>
			<el-table-column
				prop="sex_name"
				label="性别">
			</el-table-column>
			<el-table-column
				prop="birthday"
				label="出生日期">
			</el-table-column>
			<el-table-column
				prop="school"
				label="就读院校">
			</el-table-column>
			<el-table-column
				width="156"
				prop="status_name">
				<template slot="header" slot-scope="scope">
					<el-select v-model="deliver" placeholder="状态" @change="filterDataDeliver" clearable>
						<el-option label="未投递" :value=1 key="1"></el-option>
						<el-option label="已投递" :value=0 key="0"></el-option>
					</el-select>
				</template>
			</el-table-column>
			<el-table-column
				prop="create_time"
				label="投递时间">
			</el-table-column>
			<el-table-column
				label="操作">
				<template slot-scope="scope">
					<el-button type="text" size="mini" @click="handleViewDetail(scope.row)">查看详情</el-button>
					<el-button type="text" size="mini" @click="handleStatus(scope.row.status, scope.row.id)">修改状态</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div v-if="dataList.length !== 0" class="page_container">
			<el-pagination
				background
				layout="prev, pager, next"
				@current-change="getPageList"
				:current-page.sync="page"
				:page-size="page_size"
				:total="total">
			</el-pagination>
		</div>
		<el-dialog title="查看学生详情" :visible.sync="dialogDetail" custom-class="larger_dialog">
			<div class="dialog_content">
				<el-row :gutter="20">
					<el-col :span="8"><div class="row_content">学生姓名：{{ info.username }}</div></el-col>
					<el-col :span="8"><div class="row_content">性别：{{ info.sex_name }}</div></el-col>
					<el-col :span="8"><div class="row_content">出生日期：{{ info.birthday }}</div></el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="8"><div class="row_content">籍贯：{{ info.birthplace }}</div></el-col>
					<el-col :span="8"><div class="row_content">就读院校：{{ info.school }}</div></el-col>
					<el-col :span="8"><div class="row_content">专业：{{ info.major }}</div></el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="8"><div class="row_content">学历：{{ info.education }}</div></el-col>
					<el-col :span="8"><div class="row_content">证件号：{{ info.idcard }}</div></el-col>
					<el-col :span="8"><div class="row_content">手机号码：{{ info.mobile }}</div></el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="8"><div class="row_content">邮箱：{{ info.email }}</div></el-col>
					<el-col :span="8"><div class="row_content">所属企业：{{ info.p_company_name }}</div></el-col>
					<el-col :span="8"><div class="row_content">所属子公司：{{ info.company_name }}</div></el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="8"><div class="row_content">职位名称：{{ info.position_name }}</div></el-col>
					<el-col :span="8"><div class="row_content">投递时间：{{ info.create_time }}</div></el-col>
					<el-col :span="8"><div class="row_content">状态：{{ info.status_name }}</div></el-col>
				</el-row>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogDetail = false">关 闭</el-button>
				<el-button type="primary" @click="handleStatus(info.status, info.id)">修改状态</el-button>
			</span>
		</el-dialog>
		<el-dialog title="修改投递状态" :visible.sync="dialogStatus" custom-class="self_dialog">
			<div class="dialog_inner">
				<el-radio v-model="deliverStatus" :label=1>未投递</el-radio>
				<el-radio v-model="deliverStatus" :label=0>已投递</el-radio>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogStatus = false">取 消</el-button>
				<el-button type="primary" @click="handleStatusSubmit()">确认修改</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { host } from '../utils/host.js';
	import { getLocalStorage } from '../utils/localStorage.js';
	import { downloadFile } from '../utils/fn.js';
	export default {
		data() {
			return {
				Token: { Token: getLocalStorage()},
				fileUpload: host +'/hktopic/apply/upload',      //文件上传接收地址
				dataList: [],
				page: 1,
				page_size: 10,
				status: null,
				keyword: '',
				deliver: '',
				dialogDetail: false,
				dialogStatus: false,
				info: {},
				deliverStatus: '',
				id: 0,
			}
		},
		created() {
			this.getStudentData()
		},
		methods: {
			getStudentData() {
				this.$http.get('/hktopic/apply', {
					params: {
						page: this.page,
						page_size: this.page_size,
						keyword: this.keyword,
						status: this.status
					}
				}).then(res => {
					if (res.data.code == 0) {
						this.dataList = res.data.data.data;
						this.total = res.data.data.total;
					}
				}).catch(err => {
					console.log(err)
				})
			},
			handleStudentUpload(response) {
				if (response.code == 0) {
					this.$message.success('导入状态修改成功！');
					this.getStudentData();
				}else {
					this.$message.error('导入状态修改失败！' + response.message)
				}
			},
			exportData() {
				this.$http.get('/hktopic/apply', {
					params: {
						page_size: 0,
						keyword: this.keyword,
						status: this.status
					},
					responseType: 'blob'
				}).then(res => {
					var D = +new Date();
					downloadFile(res.data, '学生列表-'+ D +'.xls')
				}).catch(err => {
					console.log(err)
				})
			},
			getPageList(page) {
				this.page = page;
				this.getStudentData();
			},
			searchData() {
				this.page = 1;
				this.getStudentData();
			},
			filterDataDeliver(value) {
				this.page = 1;
				this.status = value;
				this.getStudentData();
			},
			handleViewDetail(item) {
				this.dialogDetail = true;
				this.info = item
			},
			handleStatus(status, id) {
				this.dialogStatus = true;
				this.deliverStatus = status;
				this.id = id;
			},
			handleStatusSubmit() {
				this.$http.put(`/hktopic/apply/${this.id}`, { status: this.deliverStatus }).then(res => {
					if (res.data.code == 0) {
						this.$message.success('状态修改成功！');
						this.dialogStatus = false;
						this.dialogDetail = false;
						this.getStudentData();
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style lang="less">
	.student_page{
		.search_bar{
			display: inline-block;
			width: 400px;
			margin-right: 20px;
		}
		.uploader-item{
			display: inline-block;
			margin-right: 20px;
		}
		.dialog_content{
			.row_content{
				padding-top: 15px;
				padding-bottom: 15px;
				font-size: 16px;
			}
		}
	}
</style>
